import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { TranslocoPipe, TranslocoService } from '@ngneat/transloco';
import { sealAnimations } from '@shipsfocus/seal';
import { Subject } from 'rxjs';

@Component({
  selector: 'event-item-dialog',
  templateUrl: './event-item-dialog.component.html',
  styles: [
    `
      .event-item-dialog .mat-mdc-dialog-container .mat-mdc-dialog-surface {
        padding: 0 !important;
      }
    `
  ],
  encapsulation: ViewEncapsulation.None,
  animations: sealAnimations,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, ReactiveFormsModule, MatButton, MatFormField, MatInput, MatDialogContent, MatDialogActions, MatIcon]
})
export class EventItemDialogComponent implements OnInit, OnDestroy {
  protected readonly translocoService: TranslocoService = inject(TranslocoService);

  manualInputControl: FormControl<string> = new FormControl<string>(null);

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(public matDialogRef: MatDialogRef<EventItemDialogComponent>) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  onCancel() {
    this.matDialogRef.close();
  }

  onSubmit() {
    this.matDialogRef.close(this.manualInputControl.getRawValue());
  }
}
